import { Outlet, useLocation } from 'react-router-dom'
import { useEffect } from 'react'

import Header from './header'
import { ThemeToggle } from './elements/themebutton'
import { CloseToProjects, isProjectDetail } from './projects/close'

export default function Layout() {
  const { pathname } = useLocation()

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'auto' })
  }, [pathname])

  return (
    <>
      <Header />
      {isProjectDetail(pathname) && <CloseToProjects />}
      <Outlet />
      <ThemeToggle />
    </>
  )
}
